"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SponsorBox = void 0;
var _components = require("@ori-ui/components");
var _icons = require("@ori-ui/icons");
var _mui = require("@ori-ui/mui");
var _environment = require("@ori/environment");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _Localization = require("../../../Localization");
var _defaultTranslations_simplifiedRegistrationBrandPartner = require("../../../constants/defaultTranslations_simplified-registration-BrandPartner");
var _contexts = require("../../../contexts");
var _models = require("../../../models");
var _api = require("../../../models/api");
var _jsxRuntime = require("react/jsx-runtime");
const RootContainer = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
}));
const StyledAvatar = (0, _mui.styled)(_mui.Avatar)(({
  theme
}) => ({
  width: '85px',
  height: '85px',
  marginBottom: theme.spacing(2),
  color: theme.palette.default.light,
  backgroundColor: theme.palette.grey[100],
  textDecoration: 'none',
  marginRight: theme.spacing(3)
}));
const StyledNameLabel = (0, _mui.styled)(_mui.Typography)(({
  theme
}) => ({
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  WebkitLineClamp: 4,
  maxHeight: 'calc(1.5em * 4)',
  marginBottom: theme.spacing(1)
}));
const NexButtton = (0, _mui.styled)(_components.Button)(({
  theme
}) => ({
  minWidth: '330px',
  marginTop: theme.spacing(8)
}));
const SponsorBox = props => {
  const {
    referral
  } = (0, _contexts.useConfiguration)();
  const {
    tenant
  } = (0, _environment.useEnvironment)();
  const {
    data: registrationData
  } = (0, _api.useRegistrationData)();
  const {
    sponsorDetailInfo,
    title,
    isVisibleNextButton,
    sponsorImage
  } = props;
  const {
    fullName
  } = sponsorDetailInfo;
  const pbs_owner = _jsCookie.default.get('pbs_owner') ?? registrationData?.internationalPbsCode;
  const isInternationalPbs =
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing -- we need logical
  referral && referral?.countryCode?.toLocaleLowerCase() !== tenant || registrationData?.internationalPbsCode;
  const sponsorName = isInternationalPbs ? pbs_owner : fullName;
  const {
    stepperData
  } = (0, _contexts.useStepperData)();
  const {
    activeStep,
    setActiveStep,
    stepsOrder
  } = stepperData;
  const {
    virtualPageAnalyticsData
  } = (0, _contexts.useVirtualPageAnalyticsData)();
  const {
    setPreviousStep
  } = virtualPageAnalyticsData;
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  const handleNextStep = () => {
    setPreviousStep(stepsOrder[activeStep]);
    setActiveStep(activeStep + 1);
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(RootContainer, {
    ...getTestIdProps('sponsorBox-sponsorForm'),
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.Typography, {
      variant: "subtitle2",
      color: "textPrimary",
      marginBottom: 3,
      fontSize: 16,
      textAlign: "left",
      children: title
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_mui.Box, {
      display: "flex",
      alignItems: "center",
      children: [fullName ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledAvatar, {
        src: isInternationalPbs ? undefined : sponsorImage,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_icons.UserFilled, {
          sx: {
            fontSize: '32px'
          }
        })
      }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledNameLabel, {
        variant: "body1",
        color: "textPrimary",
        align: "left",
        sx: {
          fontWeight: 'bold'
        },
        fontSize: 17,
        children: sponsorName
      })]
    }), isVisibleNextButton ? /*#__PURE__*/(0, _jsxRuntime.jsx)(NexButtton, {
      variant: "contained",
      color: "primary",
      onClick: () => handleNextStep(),
      ...getTestIdProps('sponsorBox-next-step-btn'),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Localization.Localization, {
        id: _models.TranslationKey.SecondStep_Button,
        defaultMessage: _defaultTranslations_simplifiedRegistrationBrandPartner.defaultTranslations.SecondStep_Button
      })
    }) : null]
  });
};
exports.SponsorBox = SponsorBox;